import {get} from 'lodash';

export default (data) => {

  return {
    heading: get(data, 'dasHeading', ''),
    filters: {
        type: get(data, 'dasType', ''),
        minPrice: get(data, 'dasMinPrice', ''),
        maxPrice: get(data, 'dasMaxPrice', ''),
        category: get(data, 'dasCategory', ''),
    },
    cta: {
        title: get(data, 'dasCta.title', ''),
        href: get(data, 'dasCta.url', ''),
        target: get(data, 'dasCta.target', ''),
        style: 'primary'
    },
    dealerId: get(data, 'dasDealerId', ''),
  }
}
